import { useDispensary } from 'src/hooks/use-dispensary';
import { useStores } from 'src/hooks/use-stores';
import { useEnterpriseMobileAppSettingsQuery } from 'types/graphql';

const useHasMobileApp = (): boolean => {
  const { apolloClient } = useStores();
  const dispensary = useDispensary();
  const enterpriseId = dispensary.retailer?.enterpriseId;

  const { data } = useEnterpriseMobileAppSettingsQuery({
    client: apolloClient,
    variables: { enterpriseId: enterpriseId ?? '' },
    skip: !enterpriseId,
  });

  const hasMobileApp =
    data?.enterpriseMobileAppSettings?.iosBundleIdentifier ??
    data?.enterpriseMobileAppSettings?.androidPackageName ??
    '';
  return !!hasMobileApp.length;
};

export default useHasMobileApp;
